export class USERConstants {
	public static readonly USER_ACCOUNT: string = "/user/session/{0}/userAccount";
	public static readonly LOG_IN: string = "/user/session/{0}/login";
	public static readonly RESET_PASSWORD: string = "/user/session/{0}/emailAddress/{1}/resetPassword";
	public static readonly LOG_OUT: string = "/user/session/{0}/account/{1}/logout";
	public static readonly PASSWORD: string = "/user/session/{0}/account/{1}/password";
	public static readonly EMAILADDRESS: string = "/user/session/{0}/account/{1}/emailAddress";
	public static readonly REGISTRATIONS: string = "/dmv/{0}/{1}/registration";
	public static readonly NOTIFICATION_SETTINGS: string = "/user/session/{0}/account/{1}/notificationSettings";
	public static readonly CONTACT_INFO: string = "/user/session/{0}/account/{1}/contactInfo";
	public static readonly PAYMENT_DEVICE: string = "/user/session/{0}/account/{1}/paymentDevice/{2}";
	public static readonly BILLING_ACCOUNT: string = "/user/session/{0}/account/{1}/billingAccount/{2}";
	public static readonly ADD_BILLING_ACCOUNT: string = "/user/session/{0}/account/{1}/billingAccount";
	public static readonly GETPAYMENTDEVICE: string = "/payment/{0}/{1}/paymentDevices";
	public static readonly ACCOUNT_CANCELLATION: string = "/user/session/{0}/account/cancellation?token={1}";
	public static readonly ACCOUNT_CANCELLATION_CONFIRMED: string = "/user/session/{0}/account/cancellation/{1}";
}
